import React, { useState } from 'react'
import styled from 'styled-components'
import { Wei } from '../../utils/types'

import { fromWei } from '../../utils/static-web3'
import { Token } from '../../logic/token/token'
import { SwapStyle } from '../Themes'
import { priceFormatter } from '../../logic/financials/precise'
import SwapFairPrice from './SwapFairPrice'


const _SwapQuotation = styled.div`
  background-color: ${({ theme }) => theme.tradePanelBackgroundColor};
  cursor: pointer;
  font-size: ${SwapStyle.normalText};
  color: ${({ theme }) => theme.shadowText};
  font-family: Montserrat-Medium, Asap, serif;
  overflow: hidden;
  outline: none;
  text-decoration: none;
  text-align: right;

  &:hover {
    opacity: 0.8;
  }
`

interface QuotationProps {
  inCurrency: Token
  outCurrency: Token
  inQuantity: string
  outAmountWei: Wei
  invertedQuotation: boolean
  tokenInValue?: number | undefined
  tokenOutValue?: number | undefined
}
function SwapQuotation(props: QuotationProps) {
  const inAmount = parseFloat(props.inQuantity)
  const outAmount = fromWei(props.outAmountWei, props.outCurrency.decimals)
  return (
	props.invertedQuotation ? (
	  <_SwapQuotation>
		1 {props.outCurrency['symbol']} = {outAmount ? priceFormatter(inAmount / outAmount) : '0'}{' '}
		{props.inCurrency['symbol']}
	  </_SwapQuotation>
	) : (
	  <_SwapQuotation>
		1 {props.inCurrency['symbol']} = {inAmount ? priceFormatter(outAmount / inAmount) : '0'}{' '}
		{props.outCurrency['symbol']}
	  </_SwapQuotation>
	)
  )
}

interface Props {
  inCurrency?: Token
  outCurrency?: Token
  inQuantity?: string
  outAmountWei?: Wei
  tokenInValue?: number | undefined
  tokenOutValue?: number | undefined
}
function SwapQuotationWrapper(props: Props) {
  const { inCurrency, outCurrency, inQuantity, outAmountWei, tokenInValue, tokenOutValue } = props
  // By design, we start inverted
  const [invertedQuotation, setInvertedQuotation] = useState(true)
  function switchQuotation() {
    setInvertedQuotation(!invertedQuotation)
  }

  return inQuantity && outAmountWei && inCurrency && outCurrency ? (
  <div style={{
    padding:'1rem 0rem 1rem 0rem',
    display:'flex',
    flexDirection:'column',
    justifyContent:'space-between',
  }}>
    <div onClick={switchQuotation} className='mb5'>
      <SwapQuotation
        invertedQuotation={invertedQuotation}
        inQuantity={inQuantity}
        outAmountWei={outAmountWei}
        inCurrency={inCurrency}
        outCurrency={outCurrency}
        tokenInValue={tokenInValue}
        tokenOutValue={tokenOutValue}
      />
    </div>
    <SwapFairPrice
      tokenInValue={props.tokenInValue}
      tokenOutValue={props.tokenOutValue}
    />
  </div>
  ) : (
    <_SwapQuotation></_SwapQuotation>
  )
}

export default SwapQuotationWrapper
